import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const AuditLogDetails = React.lazy(
  () => import('components/AuditLog/Details/Details'),
);

function ScreensAuditLogDetails(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout>
      <DocumentTitle>Audit Log Details</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <AuditLogDetails id={Number(params.id)} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensAuditLogDetails;
